import React from "react";
import { Row, Col, Button, Input, Form, Space } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import classes from "./style/SearchForm.module.css";
import { ISearchForm } from "../../interfaces/props/ISearchForm";

export const SearchForm: React.FC<ISearchForm> = ({
  handleSearch,
  placeholder,
  icon = <SearchOutlined />,
}) => {
  const [form] = Form.useForm();

  return (
    <Form
      form={form}
      autoComplete="off"
      name="search"
      onFieldsChange={(value) => handleSearch(value)}
    >
      <Row>
        <Space.Compact block size="small">
          <Col flex="auto">
            <Form.Item name="search" rules={[{ type: "string" }]} noStyle>
              <Input
                placeholder={placeholder}
                className={classes.formInput}
                type="search"
                allowClear
              />
            </Form.Item>
          </Col>
          <Col flex="45px">
            <Form.Item noStyle>
              <Button
                type="text"
                htmlType="submit"
                className={classes.formButton}
              >
               { icon } 
              </Button>
            </Form.Item>
          </Col>
        </Space.Compact>
      </Row>
    </Form>
  );
};
